
import React, { useEffect, useState, lazy, Suspense } from 'react';
import NavBar from '@/components/NavBar';
import SourcingHero from '@/components/sourcing/Hero';
import SimpleProcess from '@/components/sourcing/SimpleProcess';
import { preloadCriticalAssets, initLazyLoading } from '@/services/PerformanceOptimizer';

const HowItWorks = lazy(() => import('@/components/HowItWorks'));
const CustomerSuccessStories = lazy(() => import('@/components/CustomerSuccessStories'));
const VariantTable = lazy(() => import('@/components/VariantTable'));
const ATSIntegrations = lazy(() => import('@/components/ATSIntegrations'));
const FAQ = lazy(() => import('@/components/sourcing/FAQ'));
const Footer = lazy(() => import('@/components/MainFooter'));

const LoadingFallback = () => (
  <div className="flex justify-center items-center py-6">
    <div className="animate-pulse h-8 w-full max-w-md bg-gray-100 rounded-lg"></div>
  </div>
);

const SourcingAssistant = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    document.title = "Boost your talent pipeline at 3.5% fees";
    setIsLoaded(true);
    
    preloadCriticalAssets([
      "/lovable-uploads/00525eb1-861d-450e-aded-1102c0cae4e7.png",
      "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png",
    ]);
    
    initLazyLoading();
    
    if (window.performance) {
      const perfData = window.performance.timing;
      const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart;
      console.log('Page load time:', pageLoadTime);
    }
  }, []);

  return (
    <div className="min-h-screen transition-opacity duration-300">
      <NavBar />
      <main>
        <SourcingHero />
        <Suspense fallback={<LoadingFallback />}>
          <HowItWorks />
        </Suspense>
        <SimpleProcess />
        
        <Suspense fallback={<LoadingFallback />}>
          <CustomerSuccessStories />
        </Suspense>
        
        <Suspense fallback={<LoadingFallback />}>
          <VariantTable />
        </Suspense>
        
        <Suspense fallback={<LoadingFallback />}>
          <ATSIntegrations />
        </Suspense>
        
        <Suspense fallback={<LoadingFallback />}>
          <FAQ />
        </Suspense>
      </main>
      
      <Suspense fallback={<LoadingFallback />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default SourcingAssistant;
